// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"1a318fb3","70":"30f815a1","139":"d03eea9a","253":"c06af10f","332":"6cee6fca","396":"2e373897","560":"d957cd07","801":"d36f48cf","865":"a202ad97"}[chunkId] + ".chunk.js";
};